import * as React from 'react';
import { connect } from 'react-redux';

import { User } from '@topconagriculture/frontend-utils';
import { getUserProfile } from '@topconagriculture/profiling';

import { RootState } from '../store/reducers';

function withUserProfile(Comp: React.FunctionComponent<{ children?: React.ReactNode }>) {
  class WrappedComponent extends React.Component {
    public render() {
      return <Comp {...this.props} />;
    }
  }

  const mapStateToProps = (state: RootState) => ({ user: getUserProfile(state) });
  return connect(mapStateToProps)(WrappedComponent);
}

export interface WithUserProfile {
  user: User;
}

export default withUserProfile;
